export default __webpack_public_path__ + "static/media/customer-deployment-scenarios-v2.865a6439.png";